import UserPage from "./user.react";
import UserFormPage from "./user-form.react";

export {
  UserPage,
  UserFormPage
};



// WEBPACK FOOTER //
// ./src/user/index.js